<div class="overlay-page">
  <div nxLayout="grid maxwidth">
    <div nxRow>
      <div nxCol>
        <div class="nx-margin-top-s">
          <ps20-frontend-link
            icon="arrow-left"
            (linkClick)="backToShop()"
            [text]="'forwardedToUnderwriterPage.backToShop' | text">
          </ps20-frontend-link>
        </div>
        <div class="content">
          <img
            ngSrc="assets/underwriter-info.png"
            height="160"
            width="228"
            alt=""
            class="center" />
          <h2
            nxHeadline="section"
            class="nx-margin-top-3m nx-margin-bottom-s u-text-center">
            {{ "forwardedToUnderwriterPage.header" | text }}
          </h2>
          <p
            nxCopytext="normal"
            class="overlay-page-message"
            [innerHTML]="'forwardedToUnderwriterPage.text' | html"></p>
        </div>
        <div class="text-center">
          <button
            type="submit"
            nxButton="primary"
            class="nx-margin-top-4xl nx-margin-bottom-m center"
            (click)="backToShop()">
            {{ "forwardedToUnderwriterPage.backToShop" | text }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
